import { Injectable } from '@angular/core';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { UserUpdateOptions } from '../../../../../../../../common/src/options/user-update.options';
import { FormFactory } from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { AuthService } from '@auth0/auth0-angular';

@Injectable()
export class UserUpdateFormFactory {
  constructor(
    protected readonly formFactory: FormFactory,
    private readonly auth: AuthService) {
  }

  create(): AdvancedForm<UserUpdateOptions> {
    const advancedForm = this.formFactory.create(new UserUpdateOptions(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Sauvegarder', ButtonTypeEnum.Submit),
    ]);

    advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

    this.auth.user$.subscribe((user) => {
      (advancedForm.formElements.firstName as AdvancedFormControl<string, string, string>).setNormalizedValue(user.given_name);
      (advancedForm.formElements.lastName as AdvancedFormControl<string, string, string>).setNormalizedValue(user.family_name);

      advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
    });

    return advancedForm;
  }
}
